/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react'
import { AsideMenuItem } from './AsideMenuItem'
import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import NavItem from '../../../../app/components/NavItem';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../../setup';
import { checkDeviceIds, createCloudSolo, createMSConnection, createOldPlanningTool, createPlanningTool, deleteCloudSolo, deleteOldPlanningTool, deletePlanningTool, findCustomerData, refreshLicences, updateLicences } from '../../../../app/pages/customer/redux/CustomerCRUD';
import { UserModel } from '../../../../app/pages/auth/models/UserModel';
import { downLoadLicenceFile, syncServer, updateSystemUsers } from '../../../../app/pages/user/redux/UserCRUD';
import XLSX from 'sheetjs-style'
import { useAuth } from '../../../../setup/context/AppContext';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as customer from '../../../../app/pages/customer/redux/CustomerRedux';
var XMLParser = require('react-xml-parser');

export function AsideMenuMain() {
  const intl = useIntl();
  const id: any = useSelector<RootState>(({ search }) => search.companyId, shallowEqual) as any;
  // eslint-disable-next-line
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  // eslint-disable-next-line
  const [loading, setLoading] = useState<boolean>(false);
  const [loading4, setLoading4] = useState<boolean>(false);
  const [loading5, setLoading5] = useState<boolean>(false);
  // eslint-disable-next-line
  const [loading1, setLoading1] = useState<boolean>(false);
  const [loading2, setLoading2] = useState<boolean>(false);
  // eslint-disable-next-line
  const [loading3, setLoading3] = useState<boolean>(false);
  const rights: any = useSelector<RootState>(({ auth }: any) => auth.rights, shallowEqual);
  const customerData: any = useSelector<RootState>(({ customer }) => customer.customer, shallowEqual) as any;

  const [customreport, setCustomReport] = useState<string>("");

  useEffect(() => {
    if (customerData?.customreporting) {
      const xml = new XMLParser().parseFromString(customerData.customreporting);
      if (xml) {
        const filter = xml.children.find((item: any) => item.name === 'name')
        if (filter) {
          setCustomReport(filter.value);
        }
      }
    } else {
      setCustomReport("");
    }
  }, [customerData])

  const handleClick = () => {
  }
  // eslint-disable-next-line
  const handleDeviceClick = () => {
    setLoading(true);
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id, saltid, salt }
    checkDeviceIds(body)
      .then((res) => {
        const { data } = res;
        setLoading(false);
        if (data.code === 0 && data.noresult) {
          window.alert("You received emtpy DeviceList from external server!!!")
        } else if (data.code === 0 && data.requestissue) {
          window.alert("You don't got any response from external server!!!")
        }
        else if (data.code === 0 && data.msg) {
          window.alert(data.msg)
        }
      })
      .catch((err) => {
        setLoading(false);
      })
  }

  //eslint-disable-next-line
  const handleDownloadLicenceFile = () => {
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet: charset=UTF-8"
    const fileEXtension = '.xlsx';
    const fileName = 'licences-' + id + fileEXtension;
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id, salt, saltid }
    downLoadLicenceFile(body)
      .then((res: any) => {
        let { data } = res;
        const licences = JSON.parse(data.licences);
        console.log(licences);
        const ws = XLSX.utils.json_to_sheet(licences);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
        const file = new Blob([excelBuffer], { type: fileType });

        const url = window.URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((error: any) => {
        console.log(error)
      })
  }

  const handleCreatMSConnection = () => {
    setLoading1(true);
    const salt = user?.salt;
    const saltid = user?.saltid;
    const body = { id, saltid, salt }
    createMSConnection(body)
      .then((res) => {
        const { data } = res;
        setLoading1(false);
        if (data.code === 1) {
          var a = document.createElement("a"); //Create <a>
          a.href = "data:application/octet-stream;base64," + data.xml; //Image Base64 Goes here
          a.download = 'mobisync.xml'; //File name Here
          a.click(); //Downloaded file
        }
      })
      .catch((err) => {
        setLoading1(false);
      })
  }

  const handleGitLabClick = () => {
    window.open(`https://gitlab.com/InnovationTeam/customer-settings/-/tree/master/${id}/cfg`, "_blank");
  }

  const handleRefreshLicences = () => {
    setLoading2(true);
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { saltid, salt }
    refreshLicences(body)
      .then((res) => {
        setLoading2(false)
        // window.alert("Refresh License Success")
      })
      .catch((err) => {
        setLoading2(false)
        // window.alert("Refresh License Failed")
      })
  }

  const [syncing, setSyncing] = useState<boolean>(false);
  //eslint-disable-next-line
  const [systemLoading, setSystemLoading] = useState<boolean>(false);

  const SyncServer = () => {
    setSyncing(true)
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id, salt, saltid };
    syncServer(body)
      .then((res) => {
        const { data } = res;
        if (data.code === 0) {
          setSyncing(false)
        } else {
          setSyncing(false)
        }
      })
      .catch((err) => {
        setSyncing(false)
      })
  }

  //eslint-disable-next-line
  const handleUpdateSystemUsers = () => {
    setSystemLoading(true)
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id, salt, saltid };
    updateSystemUsers(body)
      .then((res) => {
        const { data } = res;
        if (data.code === 0) {
          setSystemLoading(false)
        } else {
          setSystemLoading(false)
        }
      })
      .catch((err) => {
        setSystemLoading(false)
      })
  }

  // eslint-disable-next-line
  const handleUpdateLicences = () => {
    setLoading3(true);
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id, saltid, salt }
    updateLicences(body)
      .then((res) => {
        setLoading3(false)
        // window.alert("Refresh License Success")
      })
      .catch((err) => {
        setLoading3(false)
        // window.alert("Refresh License Failed")
      })
  }

  const { currentStep, handleCurrentStep, handleShowCompany } = useAuth();
  const [back, setBack] = useState(false);

  const history = useHistory();

  const handleBack = () => {
    if (rights['admin_allsystems'] || rights['admin_ownagentsystems']) {
      handleCurrentStep(2);
      setBack(true)
      handleShowCompany(false);
    }
  }

  useEffect(() => {
    if (currentStep === 2 && back) {
      history.push('/searchFilter')
      setBack(false);
    }
    //eslint-disable-next-line
  }, [currentStep, back])

  const handleSearch = () => {
    if (rights['admin_allsystems'] || rights['admin_ownagentsystems']) {
      history.push('/searchFilter')
      handleCurrentStep(1);
    }
  }

  const dispatch = useDispatch();

  const handleCustomer = () => {
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id: id, salt, saltid };
    findCustomerData(body)
      .then((res) => {
        const { data } = res;
        dispatch(customer.actions.setCustomerData(data));
      })
      .catch((err) => {
        debugger
      })
  }

  const handleCreateCloudSolo = () => {
    setLoading4(true);
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id, saltid, salt }
    createCloudSolo(body)
      .then((res: any) => {
        setLoading4(false)
        handleCustomer()
        if (res.data.code === 0) {
          // @ts-ignore
          Swal.fire({
            text: `DB connection failed \n DB : ${res.data.url}`,
            icon: "error",
            showCancelButton: false,
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary",
            }
          }).then(async function (result: any) {
          });
        }
      })
      .catch((err) => {
        setLoading4(false)
      })
  }

  const handleDeleteCloudSolo = () => {
    setLoading4(true);
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id, saltid, salt }
    deleteCloudSolo(body)
      .then((res: any) => {
        setLoading4(false)
        handleCustomer();
      })
      .catch((err) => {
        setLoading4(false)
      })
  }

  const handleDeletesolo = () => {
    // @ts-ignore
    Swal.fire({
      text: intl.formatMessage({ id: 'MENU.DELETE.CLOUDSOLO.DESC' }).replace(':customername', customerData?.description),
      icon: "warning",
      showCancelButton: true,
      buttonsStyling: false,
      confirmButtonText: intl.formatMessage({ id: 'SEARCH.DELETE' }),
      cancelButtonText: intl.formatMessage({ id: 'SEARCH.CANCEL' }),
      customClass: {
        confirmButton: "btn btn-active-light",
        cancelButton: "btn btn-primary",
      }
    }).then(async function (result: any) {
      if (result.value) {
        handleDeleteCloudSolo();
      } else if (result.dismiss === 'cancel') {

      }
    });
  }

  const handleDeletePlanning = () => {
    // @ts-ignore
    Swal.fire({
      text: intl.formatMessage({ id: 'MENU.DELETE.PLANNING.DESC' }).replace(':customername', customerData?.description),
      icon: "warning",
      showCancelButton: true,
      buttonsStyling: false,
      confirmButtonText: intl.formatMessage({ id: 'SEARCH.DELETE' }),
      cancelButtonText: intl.formatMessage({ id: 'SEARCH.CANCEL' }),
      customClass: {
        confirmButton: "btn btn-active-light",
        cancelButton: "btn btn-primary",
      }
    }).then(async function (result: any) {
      if (result.value) {
        handleDeletePlanningTool();
      } else if (result.dismiss === 'cancel') {

      }
    });
  }


  const handleCreatePlanningTool = () => {
    setLoading5(true);
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id, saltid, salt }
    const planningTool = process.env.REACT_APP_PLANNING_TOOL || "new"
    if (planningTool === "old") {
      createOldPlanningTool(body)
        .then((res) => {
          setLoading5(false)
          handleCustomer();
        })
        .catch((err) => {
          setLoading5(false)
        })
    } else {
      createPlanningTool(body)
        .then((res) => {
          setLoading5(false)
          handleCustomer();
        })
        .catch((err) => {
          setLoading5(false)
        })
    }
  }

  const handleDeletePlanningTool = () => {
    setLoading5(true);
    const saltid = user?.saltid;
    const salt = user?.salt;
    const body = { id, saltid, salt }
    const planningTool = process.env.REACT_APP_PLANNING_TOOL || "new"
    if (planningTool === "old") {
      deleteOldPlanningTool(body)
        .then((res) => {
          setLoading5(false)
          handleCustomer();
        })
        .catch((err) => {
          setLoading5(false)
        })
    } else {
      deletePlanningTool(body)
        .then((res) => {
          setLoading5(false)
          handleCustomer();
        })
        .catch((err) => {
          setLoading5(false)
        })
    }
  }


  return (
    <>
      <div className='menu-item'>
        <div className='menu-content  pb-5'>
          <div className='d-flex justify-content-center align-items-center'>
            <button
              className='btn btn-sm btn-flex btn-primary btn-active-primary fw-bolder me-2'
              style={{ height: '40px' }}
              onClick={handleSearch}
            >
              Search
            </button>
            <button
              className='btn btn-sm btn-flex btn-primary btn-active-primary fw-bolder'
              style={{ height: '40px' }}
              onClick={handleBack}
            >
              List View
            </button>
          </div>
        </div>
      </div>

      <AsideMenuItemWithSub
        to='/account'
        title={intl.formatMessage({ id: 'MENU.ACCOUNT' })}
        icon='/media/icons/duotune/communication/com005.svg'
        fontIcon='bi-person'
      >

        <AsideMenuItem to={`/account/customer/${id}`} title={intl.formatMessage({ id: 'MENU.CUSTOMER' })} hasBullet={true} />
        <AsideMenuItem to={`/account/user/${id}`} title={intl.formatMessage({ id: 'MENU.USER' })} hasBullet={true} />
        <AsideMenuItem to={`/account/license/${id}`} title={intl.formatMessage({ id: 'MENU.LICENSE' })} hasBullet={true} />

        {
          (rights['superuser'] || rights['use_update_tools'] || rights['create_system']) &&
          <AsideMenuItemWithSub to='/account/system' title={intl.formatMessage({ id: 'MENU.SYSTEM.FUNCTIONS' })} hasBullet={true}>
            {/* <NavItem
              lang='MENU.MOBI.SYNC'
              handleClick={SyncServer}
              loading={syncing}
            /> */}
            <NavItem
              lang='CREATE.SYSTEM.USERS'
              handleClick={handleUpdateSystemUsers}
              loading={systemLoading}
            />

            <div className='menu-item'>
              <div className='menu-content'>
                <div className='separator mx-1'></div>
              </div>
            </div>
            {
              rights['admin_allsystems'] &&
              <>
                <AsideMenuItem to={`/account/system/journal/${id}`} title={intl.formatMessage({ id: 'MENU.PROJECT.JOURNAL' })} hasBullet={true} />
              </>
            }
            <AsideMenuItem to={`/account/system/errorlogs/${id}`} title={intl.formatMessage({ id: 'MENU.ERROR.LOGS' })} hasBullet={true} />
            {
              rights['superuser'] &&
              <>
                <AsideMenuItem to={`/account/system/status/${id}`} title={intl.formatMessage({ id: 'MENU.SYSTEM.STATUS' })} hasBullet={true} />
              </>
            }
            <NavItem
              lang='MENU.LICENCD.LIST'
              handleClick={handleDownloadLicenceFile}
            />
            {
              rights['superuser'] &&
              <>
                <AsideMenuItem to={`/account/system/requesttable/${id}`} title={intl.formatMessage({ id: 'MENU.REQUEST.TABLE' })} hasBullet={true} />
              </>
            }
            <div className='menu-item'>
              <div className='menu-content'>
                <div className='separator mx-1'></div>
              </div>
            </div>
            <AsideMenuItem to={`/account/system/appliedscripts/${id}`} title={intl.formatMessage({ id: 'MENU.APPLYED.SCRIPTS' })} hasBullet={true} />
            {
              rights['use_update_tools'] &&
              <>
                <AsideMenuItem to={`/account/system/updatetable/${id}`} title={intl.formatMessage({ id: 'MENU.UPDATE.TABLE.XML' })} hasBullet={true} />
                <NavItem
                  lang='MENU.UPDATE.JAVA.FILES'
                  handleClick={handleClick}
                />
              </>
            }
            <AsideMenuItem to={`/account/system/reports/${id}`} title={intl.formatMessage({ id: 'MENU.REPORTS' })} hasBullet={true} />

            <div className='menu-item'>
              <div className='menu-content'>
                <div className='separator mx-1'></div>
              </div>
            </div>


            {
              rights['create_system'] &&
              <>
                <AsideMenuItem to={`/account/system/devicesettings/${id}`} title={intl.formatMessage({ id: 'MENU.DEVICE.CONFIGURATION' })} hasBullet={true} />

                <NavItem
                  lang='MENU.CREATE.MS.CONNECTION'
                  handleClick={handleCreatMSConnection}
                />
              </>
            }

            {
              rights['superuser'] &&
              <>
                <NavItem
                  lang='MENU.GITLAB'
                  handleClick={handleGitLabClick}
                />
                {
                  customerData?.cloudsolo ?
                    <NavItem
                      lang='MENU.DELETE.CLOUDSOLO'
                      handleClick={handleDeletesolo}
                      loading={loading4}
                    />
                    :
                    <NavItem
                      lang='MENU.CREATE.CLOUDSOLO'
                      handleClick={handleCreateCloudSolo}
                      loading={loading4}
                    />
                }
                {
                  customerData?.planningtool ?
                    <NavItem
                      lang='MENU.DELETE.PLANNING.TOOL'
                      handleClick={handleDeletePlanning}
                      loading={loading5}
                    />
                    :
                    <NavItem
                      lang='MENU.CREATE.PLANNING.TOOL'
                      handleClick={handleCreatePlanningTool}
                      loading={loading5}
                    />

                }
              </>
            }
          </AsideMenuItemWithSub>
        }
        {
          (rights['admin_ownsystem']) && customreport &&
          <AsideMenuItem to={`/account/customereporting/${id}`} title={customreport} hasBullet={true} />
        }
      </AsideMenuItemWithSub>



      {
        (rights['superuser'] || rights['use_update_tools'] || rights['create_system']) &&
        <>
          <div className='menu-item'>
            <div className='menu-content pt-2 pb-2'>

            </div>
          </div>

          <AsideMenuItemWithSub
            to='/maintenance'
            title={intl.formatMessage({ id: 'MENU.MAINTENANCE' })}
            icon='/media/icons/duotune/graphs/gra008.svg'
            fontIcon='bi-person'
          >

            {
              rights['superuser'] &&
              <>
                <AsideMenuItem to={`/maintenance/newcompany/${id}`} title={intl.formatMessage({ id: 'MENU.NEW.COMPANY' })} hasBullet={true} />
              </>
            }

            <AsideMenuItem to={`/maintenance/reports/${id}`} title={intl.formatMessage({ id: 'MENU.REPORTS' })} hasBullet={true} />
            <AsideMenuItem to={`/maintenance/tablexml/${id}`} title={intl.formatMessage({ id: 'MENU.TABLE.XML' })} hasBullet={true} />
            <AsideMenuItem to={`/maintenance/sqlupdates/${id}`} title={intl.formatMessage({ id: 'MENU.SQL.UPDATES' })} hasBullet={true} />

            {
              rights['superuser'] &&
              <>
                <AsideMenuItem to={`/maintenance/systembackup/${id}`} title={intl.formatMessage({ id: 'MENU.SYSTEM.BACKUP' })} hasBullet={true} />

                <NavItem
                  lang='MENU.REFRESH.LICENCES'
                  handleClick={handleRefreshLicences}
                  loading={loading2}
                />
              </>
            }
            {
              rights['superuser'] &&
              <AsideMenuItemWithSub to='/maintenance/configuration' title={intl.formatMessage({ id: 'MENU.CONFIGURATION' })} hasBullet={true}>
                <AsideMenuItem to={`/maintenance/erp/${id}`} title={intl.formatMessage({ id: 'MENU.ERP' })} hasBullet={true} />
                <AsideMenuItem to={`/maintenance/partners/${id}`} title={intl.formatMessage({ id: 'MENU.PARTNER' })} hasBullet={true} />
                {
                  rights['create_system'] &&
                  <AsideMenuItem to={`/maintenance/mails/${id}`} title={intl.formatMessage({ id: 'MENU.EMAIL.CONFIGURATION' })} hasBullet={true} />
                }
                <AsideMenuItem to={`/maintenance/freemail/${id}`} title={intl.formatMessage({ id: 'MENU.ERP.MAIL' })} hasBullet={true} />
                <AsideMenuItem to={`/maintenance/serverconfig/${id}`} title={intl.formatMessage({ id: 'MENU.SERVER.CONFIGURATION' })} hasBullet={true} />
              </AsideMenuItemWithSub>
            }
          </AsideMenuItemWithSub>
        </>
      }

      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
    </>
  )
}
